export default "__VITE_ASSET__DlRzkv5w__"